import { ActionReducerMap } from '@ngrx/store';
import { coursePlayerReducer } from '../course-player.reducer';

export const reducers: ActionReducerMap<any> = {
    coursePplayer: coursePlayerReducer
}